<template>
    <div class="main-sections text-center">
        <h3 class="h2 font-weight-bold">Hiscores</h3>
        <br>

        <div class="difficulties-row">
            <div class="header">
                <div class="icon icon-shape bg-gradient-success rounded-circle text-white">
                    <i class="ni ni-support-16"></i>
                </div>
                <div class="text-container">
                    <h5 class="heading text-success mb-md-1">Easy</h5>
                </div>
                <div class="entries-container">
                    <HiscoreEntryRow v-for="entry in easyEntries.filter(e => e !== null)" :key="entry.id"
                        :entry="entry" />
                </div>
            </div>
            <div class="header">
                <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                    <i class="ni ni-send"></i>
                </div>
                <div class="text-container">
                    <h5 class="heading text-warning mb-md-1">Normal</h5>
                </div>
                <div class="entries-container">
                    <HiscoreEntryRow v-for="entry in normalEntries.filter(e => e !== null)" :key="entry.id"
                        :entry="entry" />
                </div>
            </div>
            <div class="header">
                <div class="icon icon-shape bg-gradient-danger rounded-circle text-white">
                    <i class="ni ni-spaceship"></i>
                </div>
                <div class="text-container">
                    <h5 class="heading text-danger mb-md-1">Hard</h5>
                </div>
                <div class="entries-container">
                    <HiscoreEntryRow v-for="entry in hardEntries.filter(e => e !== null)" :key="entry.id"
                        :entry="entry" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import HiscoreEntryRow from './components/HiscoreEntryRow.vue';
import ButtonRow from './components/ButtonRow.vue';

export default {
    components: {
        HiscoreEntryRow,
        ButtonRow
    },
    data() {
        return {
            easyEntries: [],
            normalEntries: [],
            hardEntries: [],
            defaultEntryCount: 10,
            fetchIntervalId: null
        };
    },
    mounted() {
        this.setDefaultEntryCount();
    },
    methods: {
        setDefaultEntryCount() {
            console.log(`width is ${window.innerWidth}`)
            if (window.innerWidth <= 768) { // Mobile breakpoint (can adjust as needed)
                this.defaultEntryCount = 5;
            } else {
                this.defaultEntryCount = 10;
            }
        },
        async fetchHiscoreEntries(difficulty) {
            const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
            try {
                const response = await axios.get(`${apiBaseUrl}/api/hiscores/`, {
                    params: {
                        difficulty: difficulty,
                        count: this.defaultEntryCount
                    }
                });
                return response.data;
            } catch (error) {
                console.error(`Failed to fetch ${difficulty} hiscore entries:`, error);
                return [];
            }
        },
        async fetchAndFillEntries() {
            const easyEntries = await this.fetchHiscoreEntries('EASY');
            const normalEntries = await this.fetchHiscoreEntries('NORMAL');
            const hardEntries = await this.fetchHiscoreEntries('HARD');

            this.easyEntries = this.fillEntries(easyEntries);
            this.normalEntries = this.fillEntries(normalEntries);
            this.hardEntries = this.fillEntries(hardEntries);
        },
        fillEntries(entries) {
            const filledEntries = [];
            for (let i = 0; i < this.defaultEntryCount; i++) {
                filledEntries.push(entries[i] || null);
            }
            return filledEntries;
        },
        startFetchInterval() {
            this.fetchIntervalId = setInterval(() => {
                this.fetchAndFillEntries();
            }, 60000);
        },
        clearFetchInterval() {
            if (this.fetchIntervalId) {
                clearInterval(this.fetchIntervalId);
            }
        }
    },
    async mounted() {
        await this.fetchAndFillEntries();
        this.startFetchInterval();
    },
    beforeDestroy() {
        this.clearFetchInterval();
    }
};

</script>

<style scoped>
.difficulties-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 80%;
    margin: auto;
    /* Centers the row if it's narrower than the viewport */
}

.header {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Center horizontally */
    flex: 1 1 33%;
    /* Each column takes 1/3 of the container width */
    box-sizing: border-box;
    /* Ensure padding and borders are included in the width */
    margin-bottom: 1rem;
    /* Add space between rows when they stack */
    padding: 0 0.5rem;
    /* Horizontal padding for margin between columns */
}

/* Remove margin on the last column */
.difficulties-row .header:last-child {
    padding-right: 0;
}

.icon {
    margin-bottom: 0.5rem;
    /* Space between icon and text */
}

.text-container {
    text-align: center;
    /* Center the text horizontally under the icon */
    margin-bottom: 1rem;
    /* Space between text and entries */
}

.entries-container {
    width: 100%;
    /* Ensure the entries container takes the full width */
}

@media (max-width: 768px) {
    .header {
        flex-basis: 100%;
        /* On smaller screens, each column takes full width */
        max-width: 100%;
        /* Ensure columns do not exceed the container's width */
        padding: 0;
        /* Remove padding on smaller screens */
    }

    .difficulties-row {
        padding: 0 15px;
        /* Adjust as needed */
    }
}

.entry {
    margin-top: 0.5rem;
    text-align: left;
}
</style>
